export interface PreApplicationFormValues {
  isInternationalStudent: string;
  primaryReasonForStudying: string;
  understandsFinancialCosts: string;
  estimatedAnnualLivingCost: string;
  fundingSource: string;
  workStudyExpectation: string;
  understandsVisaRequirements: string;
  understandsVisaIsTemporary: string;
  confirmsGenuineIntention: string;
}

export interface PreApplicationResult {
  owner: string;
  preApplicationId: string;
  userId: string;
  isInternationalStudent: string;
  primaryReasonForStudying: string;
  understandsFinancialCosts: string;
  estimatedAnnualLivingCost: string;
  fundingSource: string;
  workStudyExpectation: string;
  understandsVisaRequirements: string;
  understandsVisaIsTemporary: string;
  confirmsGenuineIntention: string;
  result: {
    evaluatedAt: string;
    breakdown: {
      overallOutcome: PreApplicationOutcome;
      checkStudyPurpose: BreakdownItem;
      checkFinancialResponsibility: BreakdownItem;
      checkEligibilityAwareness: BreakdownItem;
    };
  };
  submittedAt: string;
  createdAt: string;
  updatedAt: string;
  institutionIds: string[] | null;
  partnerIds: string[] | null;
}

export interface BreakdownItem {
  outcome: PreApplicationOutcome;
  feedback: string;
  studentMessage: string;
}

export enum PreApplicationOutcome {
  PASS = "PASS",
  EXCLUSION = "EXCLUSION",
  REVIEW = "REVIEW",
}
